export enum CERTIFICATES_TYPES {
  GET_CERTIFICATES_REQUEST = '@certificates/GET_CERTIFICATES_REQUEST',
  SET_DATA_CERTIFICATES = '@certificates/SET_DATA_CERTIFICATES',
  SET_ERROR = '@certificates/SET_ERROR',
}

export interface Certificates {
  response: any;
  hasMore?: boolean;
}
export interface CertificatesState {
  certificates: Certificates;
  error: string;
}

export interface GetCertificates {
  period?: string;
  limit?: string;
  showMore?: boolean;
}

export interface Certificate {
  id: string;
  pdvNumber: string;
  typeCertificate: string;
  validSince: string;
  validUntil: string;
  period: string;
}
